package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSRequest

data class FileUploadRequestBody(
    val fileName: String,
    val fileContent: ByteArray,
    val contentType: String
) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as FileUploadRequestBody

        if (fileName != other.fileName) return false
        if (!fileContent.contentEquals(other.fileContent)) return false
        if (contentType != other.contentType) return false

        return true
    }

    override fun hashCode(): Int {
        var result = fileName.hashCode()
        result = 31 * result + fileContent.contentHashCode()
        result = 31 * result + contentType.hashCode()
        return result
    }
}

class WMJobDescriptionFileUploadRequestBuilder: WMEventStreamReferencingRequestBuilder<
        WMJobDescriptionFileUploadRequestBuilder,
        FileUploadRequestBody
>() {
    override fun build(): FSRequest<FileUploadRequestBody> {
        method(FSRequest.Method.Post)
        replacePathParams(listOf("api", "v1", "upload-jd"))
        return super.build()
    }

    override fun self(): WMJobDescriptionFileUploadRequestBuilder = this
}